(() => {
  'use strict';
  const panel = document.querySelector('[data-zv-sms-choice]');
  const choices = document.querySelector('[data-zv-channel-options]');
  const form = document.querySelector('form[data-zv-simple]');
  if (!panel || !choices || !form || panel.dataset.enabled.trim() !== 'true' || window.ZVShop?.country !== 'US' || form.dataset.reservationsOpen !== 'true') return;
  const template = panel.querySelector('template'), host = panel.querySelector('[data-zv-sms-host]');
  const radios = [...choices.querySelectorAll('input')];
  let frame, token, timer, busy = false, finished = false;
  const lock = () => { const locked=busy || form.getAttribute('aria-busy') === 'true';radios.forEach(input => { input.disabled = locked; });window.ZVPreferenceUI?.lock(locked); };
  const email = () => {
    if (busy || finished) return;
    clearTimeout(timer);
    frame = null;
    host.replaceChildren();
    panel.hidden = true;
    form.hidden = false;
    radios[0].checked = true;
    radios[0].focus();
  };
  function open() {
    token = crypto.randomUUID();
    frame = document.createElement('iframe');
    frame.title = panel.dataset.title;
    frame.setAttribute('sandbox','allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox');
    frame.setAttribute('referrerpolicy','no-referrer');
    frame.style.cssText = 'width:100%;height:850px;display:block;border:0;background:transparent';
    frame.srcdoc = template.innerHTML.replaceAll('__ZV_CHANNEL__',token).replaceAll('__ZV_PARENT__',location.origin);
    host.replaceChildren(frame);
    panel.querySelector('[data-zv-sms-loading]').hidden = false;
    panel.querySelector('[data-zv-sms-failure]').hidden = true;
    form.hidden = true;
    panel.hidden = false;
    timer = setTimeout(() => {
      panel.querySelector('[data-zv-sms-loading]').hidden = true;
      panel.querySelector('[data-zv-sms-failure]').hidden = false;
      host.replaceChildren();
      frame = null;
    },15000);
  }
  window.addEventListener('message', event => {
    const data = event.data;
    if (!frame || event.source !== frame.contentWindow || event.origin !== 'null' || data?.type !== 'zuvie-sms' || data.token !== token) return;
    if (data.kind === 'ready') {
      clearTimeout(timer);
      panel.querySelector('[data-zv-sms-loading]').hidden = true;
      const source = window.ZVPath?.snapshot();
      frame.contentWindow.postMessage({
        type:'zuvie-sms-init',token,price:window.ZVShop.priceDisplay,
        purchasePreference:window.ZVPurchasePreference?.() ?? (typeof zvInitialPurchasePreference === 'function' ? zvInitialPurchasePreference() : ''),
        preferenceSource:window.ZVPreferenceSource?.(),preferenceAsked:!!document.querySelector('[data-zv-reserve-preference]'),
        refillWeeks:window.ZVRefillWeeks?.() ?? (typeof zvInitialRefillWeeks === 'function' ? zvInitialRefillWeeks() : ''),
        eventSource:source ? window.ZVPath.eventFields(source) : {},
        profileSource:source ? window.ZVPath.profileFields(source) : {}
      }, '*');
    } else if (data.kind === 'resize' && Number.isFinite(data.height)) {
      frame.style.height = Math.max(300, Math.min(1800, data.height)) + 'px';
    } else if (data.kind === 'close') email();
    else if (data.kind === 'busy') { busy = true; lock(); }
    else if (data.kind === 'idle') { busy = false; lock(); }
    else if (data.kind === 'pending') { finished = true; choices.hidden = true; window.ZVPreferenceUI?.complete(); }
  });
  window.addEventListener('zuvie-preference-change',()=>{
    if(!frame || busy || finished)return;
    frame.contentWindow.postMessage({type:'zuvie-sms-preference',token,
      purchasePreference:window.ZVPurchasePreference?.() || '',refillWeeks:window.ZVRefillWeeks?.() || '',
      preferenceSource:window.ZVPreferenceSource?.(),preferenceAsked:!!document.querySelector('[data-zv-reserve-preference]')},'*');
  });
  panel.querySelector('[data-zv-sms-fallback]').addEventListener('click',email);
  radios.forEach(input => input.addEventListener('change',() => {
    if (busy || finished || form.getAttribute('aria-busy') === 'true') return;
    if (input.value === 'sms' && input.checked) open();
    else if (input.checked) email();
  }));
  new MutationObserver(lock).observe(form,{attributes:true,attributeFilter:['aria-busy']});
  function mode() {
    const isJoin = form.querySelector('input[name="mode"]:checked')?.value === 'join';
    choices.hidden = finished || isJoin;
    if (isJoin && !panel.hidden) email();
  }
  form.querySelectorAll('input[name="mode"]').forEach(input=>input.addEventListener('change',mode));
  form.querySelector('[data-zv-ab-join]')?.addEventListener('click',()=>queueMicrotask(mode));
  window.ZVReservationUI = { attach() { finished = true; choices.hidden = true; window.ZVPreferenceUI?.complete(); } };
  mode();
})();

